/**
 * The optional "Booking reference of the other trip" at checkout (2026-10-08),
 * asked when a customer says their companions are on another Defera booking.
 * Saved on the booking as flight_data.companion_booking_reference; when it
 * matches a trip on the SAME account, the database links the two bookings for
 * the ops team (trg_link_companion_booking, migrations 172/173). A trip on
 * someone else's account is never linked from a typed reference: staff confirm
 * with both travelers and link it themselves.
 */

/** Defera references are 6 letters and digits (a few old ones run to 10). */
export const COMPANION_REFERENCE_MAX = 10;

/** As typed → as stored: "jz-ahbd " → "JZAHBD". */
export function normalizeCompanionReference(raw) {
  return String(raw ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, COMPANION_REFERENCE_MAX);
}
